// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1omr0","option":"styles_option__1ZIMI","active":"styles_active__2kaHM"};